import stMyConnectAuth from './myConnectAuth.component';
import stMyConnectButton from './myConnectButton.component';

export default angular
  .module('st.Integrations.MyConnect', ['st.Core', 'angular-cache'])
  .component('stMyConnectAuth', stMyConnectAuth)
  .component('stMyConnectButton', stMyConnectButton)
  .service('myConnectService', ($http, dataService, MY_CONNECT) => ({
    refer: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        MY_CONNECT.API.REFER,
        {
          params
        },
        null,
        true
      )
  }))
  .constant('MY_CONNECT', {
    API: {
      REFER: '/api/v1/integrations/my-connect/refer/'
    }
  });
